@import '../../styles/modals.css';

.account-wrapper__tabs {
  display: flex;
  align-items: center;
  background: #f8f9fa;
  border-bottom: 1px solid #d5d9de;
  height: 51px;
  width: 100%;
}

.account-wrapper__tabs div {
  margin-left: 10px;
  color: #696c74;
  font-size: 12px;
  line-height: 18px;
  padding: 17px 0 16px;
  text-align: center;
  text-decoration: none;
  width: 33%;
}

.account-wrapper__tabs .account-wrapper__tabs__active {
  color: #232329;
  border-bottom: 2px solid #232329;
}

.account-wrapper__tabs div:hover {
  cursor: pointer;
}

.account-wrapper__tabs div:first-child {
  margin-left: 0;
}
